/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_ImportInputs */

const en_project_import = /** @type {(inputs: Project_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Import`)
};

const fr_project_import = /** @type {(inputs: Project_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation de projet`)
};

const de_project_import = /** @type {(inputs: Project_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektimport`)
};

const it_project_import = /** @type {(inputs: Project_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione del progetto`)
};

const ru_project_import = /** @type {(inputs: Project_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт проекта`)
};

const es_project_import = /** @type {(inputs: Project_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación de proyectos`)
};

const zh_cn2_project_import = /** @type {(inputs: Project_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目导入`)
};

const ja_project_import = /** @type {(inputs: Project_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトのインポート`)
};

const hi_project_import = /** @type {(inputs: Project_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट आयात`)
};

const pt_pt2_project_import = /** @type {(inputs: Project_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação de Projetos`)
};

/**
* | output |
* | --- |
* | "Project Import" |
*
* @param {Project_ImportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_import = /** @type {((inputs?: Project_ImportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_ImportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_project_import(inputs)
	if (locale === "de") return de_project_import(inputs)
	if (locale === "it") return it_project_import(inputs)
	if (locale === "ru") return ru_project_import(inputs)
	if (locale === "es") return es_project_import(inputs)
	if (locale === "zh-CN") return zh_cn2_project_import(inputs)
	if (locale === "ja") return ja_project_import(inputs)
	if (locale === "hi") return hi_project_import(inputs)
	if (locale === "pt-PT") return pt_pt2_project_import(inputs)
	return en_project_import(inputs)
});